import IconLinkButton from "components/common/controls/IconLinkButton";
import editIconSvg from "static/images/edit-icon.svg";

interface Props {
  editClicked: () => void;
}

export default function PromineoEditActionColumnButton(props: Props) {
  const { editClicked } = props;

  const handleEditClick = () => {
    editClicked();
  };

  return (
    <>
      <IconLinkButton
        text="Edit"
        icon={editIconSvg}
        onClick={handleEditClick}
      />
    </>
  );
}